export const STANDARD_CONTENT_PADDING = "px-flash-200 px-sm-0";
